module.exports = __webpack_public_path__ + "static/media/precise.92a59f18.jpg";